import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/skills/components/SkillsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
